/**
 * This is a shim for Moment that automatically sets the locale based on
 * the current momentLocale. This should be set globally and be available
 * for all users that import moment.
 */

// We alias all "moment" imports to either this file or moment-shims.js.
// Thus this file has to import the "true" copy of moment so that we don't
// cause a circular dependency.
import moment from "moment/moment.js";

import {RequestInfo} from "@khan/shared-core";

import boxesLocale from "./boxes.ts";
import {kaLocaleToMoment} from "./moment-locales.ts";

const momentLocale = kaLocaleToMoment(RequestInfo.kaLocale);

// "boxes" is the fake locale that we use for testing. momentLocale is set to
// "en" instead of "boxes" so we need to check the kaLocale for "boxes".
// Also moment doesn't actually have "boxes" locale so we use our own.
if (RequestInfo.kaLocale && RequestInfo.kaLocale === "boxes") {
    // @ts-expect-error - TS2345 - Argument of type '{ readonly months: string[]; readonly monthsShort: string[]; readonly weekdays: string[]; readonly weekdaysShort: string[]; readonly weekdaysMin: string[]; readonly longDateFormat: { readonly LT: "H:mm"; ... 4 more ...; readonly LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"; }; ... 7 more ...; readonly week: { ...; }; }' is not assignable to parameter of type 'void | LocaleSpecification | undefined'.
    moment.locale("boxes", boxesLocale);
    // Dynamically load the moment locale file
    // We use this style of import to get Webpack to understand the files
    // that we're looking for. See: webpack/plugins/moment-plugin.js
    // We don't need to load this when the locale is "en" as that's built in
    // to Moment.
} else if (momentLocale && momentLocale !== "en") {
    /* eslint-disable-next-line import/no-dynamic-require -- this is necessary
       for moment to load the locale files dynamically. */
    const locale = require(`../node_modules/moment/locale/${momentLocale}.js`);

    // And set moment to use that locale
    moment.locale(momentLocale, locale);
}

export default moment;
